import { useMutation, useQueryClient } from '@tanstack/react-query';
import { destroyCookie } from '@utils';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { sdk } from '@/services';

const AuthService = sdk.getService('AuthService');
const TIMEOUT = 500;

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: logoutMutation, isPending: isLoggingOut } = useMutation({
    mutationFn: () => AuthService.logout(),
    onSuccess: () => {
      setTimeout(() => {
        destroyCookie('token', import.meta.env.VITE_COOKIE_DOMAIN);
        queryClient.setQueryData(['profile'], null);
        navigate('login');
        window.location.reload();
      }, TIMEOUT);
    }
  });

  const logout = useCallback(() => {
    logoutMutation();
  }, [logoutMutation]);

  return { logout, isLoggingOut };
};
